import { clsx } from 'clsx';
import { FunctionComponent } from 'react';

type SpinnerProperties = {
    colour?: string;
    size?: string;
};

export const Spinner: FunctionComponent<SpinnerProperties> = ({ colour = 'text-indigo-600', size = 'size-5' }) => {
    return (
        <div
            className={clsx('animate-spin rounded-full border-2 border-solid border-current border-e-transparent', colour, size)}
            data-testid={'spinner'}
            role={'spinner'}
        />
    );
};
